import { useState } from "react";
import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { IPaymentDetail, IPaymentSearchFields, IPaymentStatistics, paymentService } from "./paymentService";
import { DEFAULT_PAGE_SIZE, DEFAULT_FIRST_PAGE_NUM, defaultMdCmParam } from "@/utils/constants";
import { ISearchPage } from "@/types/FmsTypes";
import { transPgToPagination } from "@/views/base/app/appModel";
import { convertRes2Blob } from "@/utils/exportFile";

const defaultStatistics:IPaymentStatistics = {
    diffAmount: 0
}

export const usePaymentModel = createModel(function () {
    //列表数据源
    const [dataSource, setDataSource] = useState<IPaymentDetail[]>([]);
    //查询条件
    const [searchParam, setSearchParam] = useState<IPaymentSearchFields>({});
    //分页参数
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    //表格多选id值
    const [selectedRowKeys, setSelectedRowKeys] = useState<string[]>([]);
    const [exportLoading, setExportLoading] = useState(false)
    const [statistics, setStatistics] = useState<IPaymentStatistics>(defaultStatistics)

    //设置搜索value
    const updateSearchParam = (updateParam: IPaymentSearchFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    //列表查询
    const loadData = async (page: ISearchPage = initPgCfg, searchValue: IPaymentSearchFields = searchParam) => {
        const searchParams = {
            ...searchValue,
            sourceApp: defaultMdCmParam.sourceApp,
            page: {
                pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
                pageNum: (page?.current || page?.pageNum) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
            }
        }
        let { retData } = await paymentService.page(searchParams);
        let { retData: statis } = await paymentService.statistics(searchValue);
        const { records, ...pg } = retData;
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        setStatistics(statis)
        clearSelectData();
    }

    //重置搜索参数
    const resetSearchParam = () => {
        setSearchParam({});
        setSelectedRowKeys([]);
        loadData(initPgCfg, {});
    }
    const clearSelectData = () => {
        setSelectedRowKeys([]);
    }

    //导出
    const exportApi = async (page: ISearchPage = initPgCfg, searchValue: IPaymentSearchFields = searchParam) => {
        setExportLoading(true)
        try {
            const searchParams = {
                ...searchValue,
                sourceApp: defaultMdCmParam.sourceApp,
            }
            let result = await paymentService.export(searchParams);
            convertRes2Blob(result);
            setExportLoading(false)
        } catch (error) {
            setExportLoading(false)
        }
    }

    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        exportLoading,
        statistics,
        /***method***/
        setDataSource,
        updateSearchParam,
        setSelectedRowKeys,
        resetSearchParam,
        loadData, exportApi
    }
});